import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LoginForm from './components/LoginForm';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import DeliveriesPage from './components/deliveries/DeliveriesPage';
import CategoriesPage from './components/categories/CategoriesPage';
import StreamsPage from './components/streams/StreamsPage';
import StreamCreate from './components/streams/StreamCreate';
import StreamEdit from './components/streams/StreamEdit';
import IncomingStreamsPage from './components/streams/IncomingStreamsPage';
import AdvClientsPage from './components/advertising/AdvClientsPage';
import AdvPage from './components/advertising/AdvPage';
import AdvSetsPage from './components/advertising/AdvSetsPage';
import LogosPage from './components/logos/LogosPage';
import TokenDeliveriesPage from './components/token-deliveries/TokenDeliveriesPage';
import './App.css';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        } 
      >
        {/* Nested routes for the main layout */}
        <Route index element={<Navigate to="/streams" replace />} />
        <Route path="streams" element={<StreamsPage />} />
        <Route path="streams/create" element={<StreamCreate />} />
        <Route path="streams/:id/edit" element={<StreamEdit />} />
        <Route path="incoming" element={<IncomingStreamsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="deliveries" element={<DeliveriesPage />} />
        <Route path="token-deliveries" element={<TokenDeliveriesPage />} />
        <Route path="advertising/clients" element={<AdvClientsPage />} />
        <Route path="advertising/advs" element={<AdvPage />} />
        <Route path="advertising/sets" element={<AdvSetsPage />} />
        <Route path="advertising/logos" element={<LogosPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
